const Builder = require('./BuilderBase');
const CustomizableVisibility = require('./CustomizableVisibility');
const HiddenFor = require('./HiddenFor');

module.exports = class Button extends Builder {
    constructor(title, properties) {
        super('actionElement_Button', title, properties);
    }

    /**
     *
     * @param {object} properties
     * @param {string} properties.title
     * @param {boolean} [properties.isTabAccess]
     * @param {string} properties.accessTargetId
     * @param {boolean} properties.readOnly
     */
    customizableVisibility(properties) {
        let modifier = new CustomizableVisibility({ isTabAccess: false, ...properties });
        this.addChildBlock(modifier, 'securityModifier');
        return this;
    }

    hiddenFor(role) {
        let modifier = new HiddenFor(role);
        this.addChildBlock(modifier, 'securityModifier');
        return this;
    }
};
